module.exports = __webpack_public_path__ + "static/media/logo2x.29982984.png";